import { Component } from '@angular/core';

@Component({
  selector: 'cx-multi-step-checkout-page-layout',
  templateUrl: './multi-step-checkout-page-layout.component.html',
  styleUrls: ['./multi-step-checkout-page-layout.component.scss']
})
export class MultiStepCheckoutPageLayoutComponent {}
